import { isAxiosError } from "axios";

export const API_ERRORS = [
  "calculation_failed",
  "no_savings_file",
  "incomplete_submission",
] as const;

export type ApiErrorType = (typeof API_ERRORS)[number];

interface ApiErrorResponse {
  error_type?: string;
}

export const getApiErrorType = (error: unknown): ApiErrorType | undefined => {
  if (!isAxiosError<ApiErrorResponse>(error)) return undefined;
  const value = error.response?.data.error_type;
  return API_ERRORS.find(type => type === value);
};

export const isApiErrorType = (error: unknown, errorType: ApiErrorType) =>
  getApiErrorType(error) === errorType;

export const isAlreadyPaidCheckoutError = (error: unknown): boolean =>
  isApiErrorType(error, "incomplete_submission");
